import React from 'react';
import Link from 'gatsby-link';
import * as firebase from "firebase";
import Plane from '../assets/logo-flat.svg';

const config = {
  apiKey: "AIzaSyDFC8XUZpex7E-3QtKsHwG-QTLjQrIf4EI",
  authDomain: "paper-planes-studios.firebaseapp.com",
  databaseURL: "https://paper-planes-studios.firebaseio.com",
  storageBucket: "paper-planes-studios.appspot.com",
};
firebase.initializeApp(config);

class IndexPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      success: false,
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { email } = this.state;
    this.saveEmailToDb(email);
  }

  saveEmailToDb = (email) => {
    const contactsRef = firebase.database().ref("contacts");
    const newContactsRef = contactsRef.push();
    newContactsRef.set({ email });
    this.setState({ email: "", success: true });
  }

  renderForm() {
    if (!this.state.success) {
      return (
        <form onSubmit={this.handleSubmit}>
          <div className="form-row">
            <div className="col-9">
              <input
                type="email"
                onChange={(e) => this.setState({ email: e.target.value })}
                className="form-control full-height"
                placeholder="Email..."
              />
            </div>
            <div className="col">
              <button className="btn btn__icon" type="submit">
                <img src={Plane} />
              </button>
            </div>
          </div>
        </form>
      );
    } else {
      return (
        <div className="alert alert-light">Thank you, we will be in contact soon :)</div>
      );
    }
  }

  render() {
    const { success } = this.state;
    return (
      <div>
        <section className="pp-section pp-section--hero pp-section--landing pp-section--animate pp-section--padding">
          <div className="text-center">
            <h3 className="margin__bottom--lg">Digital transformations done right so you go far.</h3>
            <p className="margin__bottom--xl">
              We'll be <span className="font--bold font--white">launching soon</span>. Get in touch now!
            </p>
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-6">
                  { this.renderForm() }
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default IndexPage;


// WEBPACK FOOTER //
// ./src/pages/index.js